module.exports = __webpack_public_path__ + "media/images/success-story7-e877586c091a0a7821567ece0661ddd7.jpg";